import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const ExpandedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background-color: #ffffff;
  border-top: 1px solid ${colors.gray300};
  margin: 0;
  
  @media (max-width: 1024px) {
    gap: 20px;
    padding: 20px;
  }
  
  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr 1.5fr 1.5fr;
  gap: 24px;
  background-color: ${colors.gray50};
  border-radius: 8px;
  padding: 24px;
  
  &:not(:last-child) {
    margin-bottom: 0;
  }
  
  @media (max-width: 1400px) {
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    gap: 16px;
    padding: 20px;
  }
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 20px;
  }
  
  @media (max-width: 768px) {
    padding: 16px;
  }
`

export const DetailsLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  grid-column: 1 / 3;
  padding-right: 24px;
  border-right: 1px solid ${colors.gray300};
  
  @media (max-width: 1024px) {
    grid-column: 1;
    padding-right: 0;
    border-right: none;
    border-bottom: 1px solid ${colors.gray300};
    padding-bottom: 24px;
    margin-bottom: 24px;
  }
`

export const ContractPairBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  background-color: transparent;
  border-radius: 8px;
  overflow: hidden;
`

export const DetailsRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  grid-column: 3 / 6;
  padding-left: 24px;
  
  @media (max-width: 1024px) {
    grid-column: 1;
    padding-left: 0;
  }
`

export const DocumentBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background-color: transparent;
  border-radius: 0;
  border: none;
  
  &:not(:last-child) {
    border-bottom: 1px solid ${colors.gray300};
  }
  
  @media (max-width: 768px) {
    padding: 16px;
    gap: 10px;
  }
`

export const DocumentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const DocumentTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
  font-weight: 600;
  color: ${colors.gray900};
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`

export const StatusBadge = styled.span<{ status: 'concluded' | 'approved' }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  background-color: ${({ status }) => 
    status === 'approved' ? '#e8f5e8' : '#e3f2fd'
  };
  color: ${({ status }) => 
    status === 'approved' ? '#2e7d32' : '#1976d2'
  };
  
  @media (max-width: 768px) {
    font-size: 0.7rem;
    padding: 3px 10px;
  }
`

export const DocumentDescription = styled.div`
  font-size: 0.875rem;
  color: ${colors.gray700};
  line-height: 1.5;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`

export const DocumentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const DocumentNumber = styled.div`
  font-size: 0.875rem;
  color: ${colors.gray700};
  font-weight: 500;
`

export const DocumentDate = styled.div`
  font-size: 0.875rem;
  color: ${colors.gray600};
`

export const DocumentAmount = styled.div<{ color: string }>`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ color }) => color};
  margin-top: 4px;
  
  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`

export const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ProjectSummary = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: #717182;
  margin-bottom: 8px;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`

export const VatInfo = styled.div`
  font-size: 0.875rem;
  color: ${colors.gray600};
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`

export const CostItemsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const CostItemBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 2px 5px;
  border-radius: 16px;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid rgba(0,0,0,0.1);
  color: ${colors.gray800};
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 6px 10px;
  }
`

export const ObjectBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid ${colors.gray300};
  
  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`


